// extracted by mini-css-extract-plugin
module.exports = {"processContainer":"styles_processContainer__3eMLm","greenContainer":"styles_greenContainer__2eNdr","link":"styles_link__1P97X"};